import * as React from 'react';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import * as Constants from '../../../common/constants';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";

const pagingItems = (props) => {
  let pageItems = new Array<number>();

  if (props.numberOfPages > 1) {
    for (let i = 1; i <= props.numberOfPages; i++) {
      pageItems.push(i);
    }
  }
  return pageItems;
}


const paginator = (props) => {

  let items = pagingItems(props);

  if (items.length < 2) {
    return null;
  }

  let paginator: Array<JSX.Element> = new Array<JSX.Element>();
  if (props.onlyArrows) {
    let startEl: Array<JSX.Element> = [
      <Button
        variant="contained" size="small"
        disabled={props.page == 1}
        key={props.page + "previous"}
        style={{ marginRight: "4px", marginBottom: "5px" }}
        onClick={() => props.paginataorClick(props.page - 1)}
      ><FontAwesomeIcon icon={faAngleRight} /></Button>,
      <Button
        variant="contained" size="small"
        key={props.page + "first"}
        disabled={props.page == 1}
        style={{ marginRight: "4px", marginBottom: "5px" }}
        onClick={() => props.paginataorClick(1)}
      ><FontAwesomeIcon icon={faAngleDoubleRight} /></Button>]
    let endEl: Array<JSX.Element> = [
      <Button
        variant="contained" size="small"
        disabled={props.page == items.length}
        key={props.page + "last"}
        style={{ marginBottom: "4px", marginRight: "4px" }}
        onClick={() => props.paginataorClick(items.length)}
      ><FontAwesomeIcon icon={faAngleDoubleLeft} /></Button>,
      <Button
        variant="contained" size="small"
        disabled={props.page == items.length}
        key={props.page + "next"}
        style={{ marginRight: "4px", marginBottom: "5px" }}
        onClick={() => props.paginataorClick(props.page + 1)}
      ><FontAwesomeIcon icon={faAngleLeft} /></Button>
    ]

    paginator = [

    ];
    if (props.page == 1) {
      paginator.splice(0, 1);
    }
    if (props.page == items.length) {
      paginator.splice(2, 1);
    }

    paginator.splice(0, 0, ...endEl);
    paginator.push(...startEl)
  }

  else {
    if (items.length <= 5) {
      paginator = items.map(item => {
        return (
          <Button
            key={item + ''}
            variant="contained" size="small"
            // disabled={props.page == item}
            color={props.page == item ? "primary" : "default"}
            style={{ marginRight: "5px", marginBottom: "5px" }}
            onClick={() => props.paginataorClick(item)}
          >{item}</Button>
        )
      })
    }

    else {

      let startEl: Array<JSX.Element> = [
        <Button
          key={props.page + "first"}
          variant="contained" size="small"
          disabled={props.page == 1}
          style={{ marginRight: "4px", marginBottom: "5px" }}
          onClick={() => props.paginataorClick(1)}
        ><FontAwesomeIcon icon={faAngleDoubleLeft} /></Button>,
        <Button
          disabled={props.page == 1}
          variant="contained" size="small"
          key={props.page + "previous"}
          style={{ marginRight: "4px", marginBottom: "5px" }}
          onClick={() => props.paginataorClick(props.page - 1)}
        ><FontAwesomeIcon icon={faAngleLeft} /></Button>]
      let endEl: Array<JSX.Element> = [
        <Button
          disabled={props.page == items.length}
          key={props.page + "next"}
          variant="contained" size="small"
          style={{ marginRight: "4px", marginBottom: "5px" }}
          onClick={() => props.paginataorClick(props.page + 1)}
        ><FontAwesomeIcon icon={faAngleRight} /></Button>,
        <Button
          disabled={props.page == items.length}
          key={props.page + "last"}
          variant="contained" size="small"
          style={{ marginBottom: "4px" }}
          onClick={() => props.paginataorClick(items.length)}
        ><FontAwesomeIcon icon={faAngleDoubleRight} /></Button>
      ]

      paginator = [
        <Button
          key={props.page - 1}
          style={{ marginRight: "4px", marginBottom: "5px" }}
          variant="contained" size="small"
          onClick={() => props.paginataorClick(props.page - 1)}
        >{props.page - 1}</Button>,
        <Button
          key={props.page}
          className="p-button-raised"
          style={{ marginRight: "4px", marginBottom: "5px" }}
          onClick={() => props.paginataorClick(props.page)}
          variant="contained" size="small"
          color="primary"
        >{props.page}</Button>,
        <Button
          key={props.page + 1}
          style={{ marginRight: "4px", marginBottom: "5px" }}
          variant="contained" size="small"
          onClick={() => props.paginataorClick(props.page + 1)}
        >{props.page + 1}</Button>
      ];
      if (props.page == 1) {
        paginator.splice(0, 1);
        paginator.push(<Button
          key={props.page + 2}
          variant="contained" size="small"
          style={{ marginRight: "4px", marginBottom: "5px" }}
          onClick={() => props.paginataorClick(props.page + 2)}
        >{props.page + 2}</Button>)
      }
      if (props.page == items.length) {
        paginator.splice(2, 1);
        paginator.splice(0, 0, <Button
          variant="contained" size="small"
          key={props.page - 2}
          style={{ marginRight: "4px", marginBottom: "5px" }}
          onClick={() => props.paginataorClick(props.page - 2)}
        >{props.page - 2}</Button>);
      }

      paginator.splice(0, 0, ...startEl);
      paginator.push(...endEl)
    }
  }
  return (
    <div>
      <MuiThemeProvider theme={Constants.paginatoorButtons}>
        {paginator}
      </MuiThemeProvider>
    </div>
  )
}

export default paginator;